module.exports = new __parcel__URL__("jordan_image.91d2c13c.jpg").toString();